import apiClient from "./client";

export const askAssistant = async (message, history = []) => {
  const response = await apiClient.post("/assistant/ask", { message, history }, { timeout: 65000 });
  return response.data;
};
